import React, { Fragment } from 'react';
import {
	Edit,
	SimpleForm,
	SelectInput,
	TextInput,
	DateTimeInput,
	Toolbar,
	SaveButton
} from 'react-admin';
import Grid from '../../components/wrapper/Grid';
import { makeStyles } from '@material-ui/core/styles';
import BlackWhiteListItemList from '../blackWhiteListItems/BlackWhiteListItemList';

const useStyles = makeStyles({
	edit: {
		marginBottom: 24
	},
	list: {
		marginBottom: 24
	}
});

const BlackWhiteListToolbar = props => (
	<Toolbar {...props}>
		<SaveButton />
	</Toolbar>
);

const BlackWhiteListEdit = props => {
	const classes = useStyles();
	return (
		<Fragment>
			<Edit {...props} className={classes.edit}>
				<SimpleForm variant="standard" toolbar={<BlackWhiteListToolbar />} redirect={'edit'}>
					<Grid container spacing={2}>
						<Grid item xs>
							<TextInput source="id" fullWidth disabled />
							<DateTimeInput source="creationDateTime" fullWidth disabled />
						</Grid>
						<Grid item xs>
							<SelectInput
								source="blackWhiteListType"
								choices={[
									{ id: 'BlackList', name: 'resources.blackWhiteLists.labels.blackList' },
									{ id: 'WhiteList', name: 'resources.blackWhiteLists.labels.whiteList' }
								]}
								fullWidth
							/>
							<TextInput source="key" fullWidth />
							<TextInput source="name" fullWidth />
						</Grid>
					</Grid>
				</SimpleForm>
			</Edit>
			<BlackWhiteListItemList
				{...props}
				title=" "
				basePath={'/blackWhiteListItems'}
				resource={'blackWhiteListItems'}
				filter={{ blackWhiteListId: props.id }}
				className={classes.list}
			/>
		</Fragment>
	);
};

export default BlackWhiteListEdit;
